import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import BatchUserUpdateConfirmDialog from '../molecules/BatchUserUpdateConfirmDialog';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    openConfirm,
    updateOpenConfirm,
    onClickAction,
    name,
    validateData,
    disabled,
    updateAction
  }) => {
    const cancelAction = () => {
      updateOpenConfirm(false);
    };
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onClickAction}
          disabled={disabled}
        >
          {name}
        </Button>
        <BatchUserUpdateConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          cancelAction={cancelAction}
          confirmAction={updateAction}
          target=""
          validateData={validateData}
        />
      </>
    );
  }
);

export default withStyles(styles)(button);
